/*
  防止一般使用者直接右鍵另存 / 拖曳 / 手機長按存圖。
  注意：這只擋得住隨手複製的人。圖片網址仍是公開的 Shopify CDN，
  開發者工具或直接開圖片網址都拿得到原圖，真正要保護請用浮水印。
*/
(function () {
  var IMAGE_SELECTOR = 'img, picture, svg, video, .media, .product-media, [style*="background-image"]';

  // 只在圖片上擋右鍵，文字仍可正常右鍵複製
  document.addEventListener('contextmenu', function (e) {
    if (e.target.closest && e.target.closest(IMAGE_SELECTOR)) e.preventDefault();
  });

  // 擋拖曳到桌面
  document.addEventListener('dragstart', function (e) {
    if (e.target.tagName === 'IMG' || (e.target.closest && e.target.closest(IMAGE_SELECTOR))) {
      e.preventDefault();
    }
  });
})();
